import $ from 'jquery';

$(() => {
    $('#htmlField').val($('main#main-content').html());
});
